<template>
  
  <!-- <div class="features" :class="{ 's_open' : isOpen }" ref="features">
    <div class="features-head" @click="isOpen = !isOpen">
      <div class="features-title">Selected Features</div>
      <div class="features-icon">
        <svg class="icon"><use href="#chevron-down"></use></svg>
      </div>
    </div>
    <div class="features-body">
      <div class="features-body-inner">
      
        <div class="features-item" v-for="(feature, index) in builder.currentSelectedFeatures" :class="{ 's_active' : feature.qty }">
          <div class="features-item-icon">
            <svg class="icon"><use href="#check"></use></svg>
          </div>
          <div class="features-item-label" v-html="feature.title"></div>
          <div class="features-item-qty"><span v-html="feature.qty" v-if="feature.qty"></span></div>
        </div>
      
      </div>
    </div>
  </div> -->
  
</template>

<script setup>
  
import { ref, computed } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const isOpen = ref(true);

</script>